import { SVGProps } from 'react';

import { COLORS } from '../../../theme/colors';
import { styleConfigs } from '../../resources/styleConfigs';

const InfoIcon = ({
  width = styleConfigs.dimensions.width40,
  height = styleConfigs.dimensions.height41,
  color = COLORS.prussianBlue,
  ...props
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    aria-hidden="true"
    focusable="false"
    width={width}
    height={height}
    viewBox="0 0 40 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.5 12.75H21.5V15.75H18.5V12.75ZM18.5 18.75H21.5V27.75H18.5V18.75ZM20 5.25C11.72 5.25 5 11.97 5 20.25C5 28.53 11.72 35.25 20 35.25C28.28 35.25 35 28.53 35 20.25C35 11.97 28.28 5.25 20 5.25ZM20 32.25C13.385 32.25 8 26.865 8 20.25C8 13.635 13.385 8.25 20 8.25C26.615 8.25 32 13.635 32 20.25C32 26.865 26.615 32.25 20 32.25Z"
      fill={color}
    />
  </svg>
);

export default InfoIcon;
